import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { setPusherClient } from 'react-pusher';
import Pusher from 'pusher-js';

import configureStore from './redux/store';
import routes from './routes';
import { PUSHER_APP_KEY, PUSHER_CLUSTER } from './constants';

Pusher.logToConsole = true;

const pusherClient = new Pusher(PUSHER_APP_KEY, {
  cluster: PUSHER_CLUSTER,
  forceTLS: true,
});

setPusherClient(pusherClient);

const store = configureStore();

render(
  <Provider store={store}>
    <Router history={browserHistory} routes={routes} />
  </Provider>,
  document.querySelector('#root')
);



// WEBPACK FOOTER //
// src/index.js